// Displays a job ad within the JS console to people within Spain
export const showJobAdIfAppropriate = (user: any) => {
  if (user.inSpain) {
    console.log(`
**************************************************************
*                                                            *
*                    WORK AT READLANG!                       *
*                                                            *
*          Full stack engineer wanted in Madrid!             *
*                                                            *
*             Go to https://readlang.com/jobs                *
*                                                            *
**************************************************************
`);
  }
};
